export default {
  state: {
    showFilterModal: false,
  },
  getters: {
    getFilterState(state) {
      return state.showFilterModal;
    },
    getAll(state) {
      return {
        showFilterModal: state.showFilterModal,
      };
    },
  },
  mutations: {
    setField(state, payload) {
      // eslint-disable-next-line no-param-reassign
      state[payload.field] = payload.value;
    },
  },
};
